var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#FFEEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.6266C20 21.44 21.7867 19.6667 24 19.6667H40C42.2133 19.6667 44 21.44 44 23.6266V38.1733C44 40.36 42.2133 42.1333 40 42.1333H38.9867C37.92 42.1333 36.9067 42.5466 36.16 43.2933L33.88 45.5466C32.84 46.5733 31.1467 46.5733 30.1067 45.5466L27.8267 43.2933C27.08 42.5466 26.0533 42.1333 25 42.1333H24C21.7867 42.1333 20 40.36 20 38.1733V29.04",
    stroke: "#FF1F8F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 30.3333C33.7156 30.3333 35.1066 28.9424 35.1066 27.2266C35.1066 25.5109 33.7156 24.12 31.9999 24.12C30.2841 24.12 28.8932 25.5109 28.8932 27.2266C28.8932 28.9424 30.2841 30.3333 31.9999 30.3333Z",
    stroke: "#FF1F8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 37.88C37.3333 35.48 34.9466 33.5334 32 33.5334C29.0533 33.5334 26.6666 35.48 26.6666 37.88",
    stroke: "#FF1F8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitedIcon);
export default __webpack_public_path__ + "static/media/invitedIcon.d9a1e43d38558b16b1d1c782e8caf9eb.svg";
export { ForwardRef as ReactComponent };